/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 発注業務可能フラグ（木曜日）
 * @export
 * @interface EnableOrderdayThu
 */
export interface EnableOrderdayThu {
}

/**
 * Check if a given object implements the EnableOrderdayThu interface.
 */
export function instanceOfEnableOrderdayThu(value: object): value is EnableOrderdayThu {
    return true;
}

export function EnableOrderdayThuFromJSON(json: any): EnableOrderdayThu {
    return EnableOrderdayThuFromJSONTyped(json, false);
}

export function EnableOrderdayThuFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableOrderdayThu {
    return json;
}

export function EnableOrderdayThuToJSON(json: any): EnableOrderdayThu {
    return EnableOrderdayThuToJSONTyped(json, false);
}

export function EnableOrderdayThuToJSONTyped(value?: EnableOrderdayThu | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

